import React, { useEffect, useState } from 'react';

// redux
import { useSelector, useDispatch } from "react-redux";
import { getLocationsData, selectLocationsData, selectGetLocationsDataStatus, selectLastLocationUpdate, resetGetLocationsDataFlags, resetLocationData } from '_redux/slices/timeline/timeline-dashboard';
import { selectAirportLocations } from '_redux/slices/timeline/timeline-areas';
import { selectFirebaseInfo } from '_redux/slices/main-screen/user';
import { selectTimelineDate } from '_redux/slices/timeline/timeline-control';
// import { selectSetBookingLocationStatus } from 'redux/slices/timeline/timeline-data';
import { selectSetBookingLocationStatus } from '_redux/slices/timeline/timeline-data';

// custom components
import { CustomSpinner } from '_atoms';
import { NormalLocationCard } from '_organisms';

// bootstrap
import { Col, Row, Pagination } from 'react-bootstrap';

// tremor 
import { Subtitle, Button } from '@tremor/react';

// functions
import { getDate } from "_utils/functions";

// styling
import { Colors, Spacing } from "_styles";

// icons
import { FiRefreshCcw } from "react-icons/fi";
import { BsLayoutSidebarReverse } from "react-icons/bs";

// constants
const itemsPerPage = 12;

//#region Component
const AirportLocations = (props) => {

    //#region redux
    const dispatch = useDispatch()

    const airportLocations = useSelector(selectAirportLocations);
    const locationsData = useSelector(selectLocationsData);
    const lastLocationUpdate = useSelector(selectLastLocationUpdate);
    const dbUser = useSelector(selectFirebaseInfo);
    const timelineDate = useSelector(selectTimelineDate);
    const setBookingLocationStatus = useSelector(selectSetBookingLocationStatus);
    const getLocationsDataStatus = useSelector(selectGetLocationsDataStatus);
    //#endregion

    //#region local states
    const [locationIds, setLocationIds] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    //#endregion

    //#region useEffect

    // reset get location data flags and empty locationsData array on first render
    useEffect(() => {
        dispatch(resetLocationData());
        dispatch(resetGetLocationsDataFlags());
        if (Array.isArray(airportLocations) && airportLocations.length > 0) {
            let tempIDS = getAirportLocationList(airportLocations);
            handleGetLocationsData(tempIDS)
        }
    }, []);

    useEffect(() => {
        if (Array.isArray(airportLocations) && airportLocations.length > 0) {
            setTotalPages(Math.ceil(airportLocations?.length / itemsPerPage));
            let tempIDS = getAirportLocationList(airportLocations);
            setLocationIds(tempIDS);
        } else {
            setTotalPages(0);
            setLocationIds([]);
        };
    }, [airportLocations]);

    useEffect(() => {
        if (locationIds.length > 0) {
            handleGetLocationsData();
        }
    }, [currentPage]);

    // Refresh locations feed when a booking location is updated
    useEffect(() => {
        if (setBookingLocationStatus === 'succeeded') {
            setTimeout(() => {
                handleGetLocationsData();
            }, 3000);
        }
    }, [setBookingLocationStatus]);

    // Refresh feed every 15 seconds
    useEffect(() => {
        const fetchData = () => {
            handleGetLocationsData();
        };

        const intervalId = setInterval(fetchData, 60000);
        return () => clearInterval(intervalId);
    }, [currentPage, locationIds, timelineDate]);
    //#endregion

    //#region Helper Functions
    // Helper function to get airport location IDs, organized by bookmarks
    const getAirportLocationList = (locations) => {
        let tempIds = [...locations];

        // Sort locations by bookmarked status
        tempIds.sort((a, b) => (b.isBookMark === true) - (a.isBookMark === true));

        // Extract and return the location IDs
        tempIds = tempIds.map((location) => location?._id);

        return tempIds;
    }
    //#endregion

    //#region Pagination Functions
    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleGetLocationsData = (tempList) => {
        let startIndex = (currentPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;
        let list = Array.isFullArray(tempList) ? tempList.slice(startIndex, endIndex) : locationIds.slice(startIndex, endIndex);


        const date = getDate(timelineDate);

        dispatch(getLocationsData({
            iata: dbUser.details.authority,
            start: date,
            end: date,
            limit: 100,
            skip: 0,
            locationsIDS: list
        }))
    }
    //#endregion

    return (
        <div style={{
            border: '1px solid lightgrey',
            borderTopWidth: '5px',
            borderTopColor: Colors.PRM_LIGHT_BLUE,
            height: props?.height,
            overflowY: 'scroll'
        }}
        >
            {/* minimize + refresh buttons */}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: Spacing.SCALE_12, marginRight: Spacing.SCALE_12, marginTop: Spacing.SCALE_4 }}>
                {props.hideMinimizeButton ? null : 
                <button style={{  padding: '8px 15px 8px 15px', backgroundColor: 'rgb(59 130 246)', border: 'transparent', borderRadius: '0.375rem' }} onClick={() => { props.setToggleAirportLocations(false) }} data-tippy-content="Hide Locations">
                    <BsLayoutSidebarReverse color={'white'} size={Spacing.SCALE_18} /> 
                </button>
            }
                <button style={{ padding: '8px 15px 8px 15px', backgroundColor: 'rgb(59 130 246)', border: 'transparent', borderRadius: '0.375rem' }} onClick={() => { handleGetLocationsData() }} data-tippy-content="Refresh Data">
                    {getLocationsDataStatus === 'loading' ? <CustomSpinner size={'small'} variant={'light'} /> : <FiRefreshCcw color={'white'} size={Spacing.SCALE_16} /> }
                </button>
            </div>

            {/* location cards */}
            <div style={{ marginLeft: Spacing.SCALE_12, marginRight: Spacing.SCALE_12 }} className='mt-2'>
                <Row>
                    {locationsData?.slice(0, 12).map((location, index) => (
                        <Col key={index} xs={12} className="mb-3">
                            <NormalLocationCard location={location} key={location.locationId} />
                        </Col>
                    ))}
                </Row>
            </div>

            {/* pagination */}
            <Row className="justify-content-center">
                <Col xs="auto" className="mt-2 d-flex justify-content-center align-items-center">
                    <Pagination size="sm" className="m-0 p-0">
                        <Pagination.Prev disabled={currentPage === 1} onClick={handlePreviousPage} />

                        <Pagination.Item active>{currentPage}</Pagination.Item>

                        <Pagination.Next disabled={currentPage === totalPages} onClick={handleNextPage} />
                    </Pagination>
                </Col>
            </Row>

            {/* last update */}
            <div style={{ flex: 5, display: 'flex', justifyContent: 'center', marginTop: Spacing.SCALE_12 }}>
                {getLocationsDataStatus === 'loading' ? null : <Subtitle>Locations Updated: {lastLocationUpdate ? lastLocationUpdate.split(':').slice(0, 2).join(':') : ""} </Subtitle>}
            </div>

        </div>
    );
};

export default AirportLocations;